<template>
  <div class="main-books-list-info">
    <HeaderMenu
      :title="$t('changeBookInfo.title')"
      :routeBackName="routeBackName"
    />
    <div class="title-content text-gray">
      {{ $t("changeBookInfo.chooseBook") }}
    </div>
    <BaseSearchBooksSettings class="info-setting padd-0" />
    <fakeScrollBar
      :lengthArray="lenghList"
      :maxViewList="maxViewList"
      :heightItem="heightItem"
      :startAt="startList"
    >
      <template v-slot:default="data">
        <div
          class="item-book-out"
          v-for="book in list.slice(data.startAt, data.endAt)"
          :key="book.id"
        >
          <BaseItemBookName
            :bookSelectedId="bookSelectedId"
            :book="book"
            @click="selectBook(book.id)"
            @change="
              selectBook(book.id);
              goToBookSettings();
            "
          />
        </div>
      </template>
    </fakeScrollBar>
    <!-- <div class="change-book-settings-block flex-center">
      <button
        :class="{ disable: bookSelectedId == 0 }"
        class="btn change-book-settings btn-larg"
        @click="goToBookSettings"
      >
        {{ $t("changeBookInfo.selectBook") }}
      </button>
    </div> -->
  </div>
</template>

<script>
import listBookAreaContainer from "@/components/listBookArea/listBookAreaContainer";
import menuService from "@/services/menu";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      activeColor: "red",
      maxAddToList: 50,
      maxViewList: 100,
      endList: 100,
      startList: 0,
      heightItem: 37,
      toAddHistory: true,
      bookSelectedId: 0,
      routeBackName: "tools",
    };
  },
  components: {
    listBookAreaContainer,
  },
  methods: {
    selectBook(bookid) {
      this.bookSelectedId = bookid;
    },
    goToBookSettings() {
      this.$store.state.menu.currentBookSelected = this.bookSelectedId;
      menuService.openBooksInfoBookDetails();
      /*   this.$router.push({
        name: "book-settings",
        params: { id: this.bookSelectedId },
      }); */
    },
  },
  computed: {
    ...mapGetters("bookList", ["getBooksForSettings"]),
    list() {
      let list = this.getBooksForSettings();

      //filter out user books
      list = list.filter((x) => x.id < 5000000);
      return list;
    },
    endListComputed() {
      if (this.lenghList == this.maxViewList) return this.maxViewList;
      else return this.endList;
    },

    lenghList() {
      return this.list.length;
    },
    heightAllList() {
      if (this.$store.state.bookList.currentListLength == 0) return "0";
      return this.$store.state.bookList.currentListLength * this.heightItem;
    },
    calcHeightRectTop() {
      // if (this.$store.state.bookList.currentListLength == 0) return "0";
      if (this.startList > 0) return this.startList * this.heightItem + "px";
      return "0";
    },
    calcHeightRectBottom() {
      if (this.$store.state.bookList.currentListLength == 0) return "0";
      let x = this.endList * this.heightItem;
      let heightRec = this.heightAllList - x;
      return heightRec + "px";
      return "100px";
    },
  },
};
</script>

<style lang="scss">
$bg-color5: #f4f4f4;
.change-book-settings {
  width: auto;
  padding: 0 10px;
  margin: 14px 0;
}
.change-book-settings-block {
  display: flex;
  // margin-top: auto;
  height: 60px;
  background-color: $bg-color5;
  border-top: 1px solid #dedede;
  height: 60px;
  background-color: $bg-color5;
  border: 1px solid #dedede;
  padding: 0 20px;
  justify-content: space-between;
}
.main-books-list-info {
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  .item-book {
    padding: 0 20px 0 20px;
    font-weight: 300;
    color: var(--custom-color1);
    &.selected {
      padding-right: 15px;
    }
    .font-icon {
      // margin-left: 11px;
      font-size: 14px;
      font-weight: 100;
    }
    .check-item {
      width: 30px;
    }
  }
}
.info-setting.div-input {
  padding: 0 20px;
  position: relative;
  // margin-bottom: 15px;
  input {
    padding-right: 29px;
    &::placeholder {
      font-size: 14px !important;
      color: #000 !important;
      font-weight: 300 !important;
    }
  }
  .icon-search {
    height: 14px;
    width: 14px;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.flex-center {
  justify-content: center !important;
}
.title-content {
  height: 36px;
  line-height: 36px;
  margin-top: 16px;
  color: var(--custom-color1);
  font-size: 14px;
  padding: 0 20px;
}
</style>
